/* eslint-disable import/prefer-default-export */
import env from '@beam-australia/react-env';

const getTasklistPath = (engine = 'default') => `/camunda/camunda/app/tasklist/${engine}/#/`;

export const camundaTasklistUrl = () => `http://${env('CAMUNDA_HOSTNAME')}${getTasklistPath()}`;
